import { useState } from 'react'
import AuditBadge from './AuditBadge'
import { formatTime } from '../utils/time'
import { MessageContent } from './MessageList'

export default function AgentMessage({ message }) {
  const { sender, content, timestamp, agent_meta, auditTrail } = message
  const agentMeta  = agent_meta || message.agentMeta || {}
  const thinking   = agentMeta.thinking
  const toolCalls  = agentMeta.tool_calls || []
  const hasThinking = thinking || toolCalls.length > 0
  const [open, setOpen] = useState(false)

  // Build the toggle label: "Thought · used tool1, tool2"
  const toolNames = [...new Set(toolCalls.map(tc => tc.name).filter(Boolean))]
  const thinkLabel = [
    thinking ? 'Thought' : null,
    toolNames.length ? `used ${toolNames.join(', ')}` : null,
  ].filter(Boolean).join(' · ') || 'Thinking'

  return (
    <>
      <div className="message-avatar agent-avatar">
        <span className="avatar-initials">{sender?.initials || '🤖'}</span>
        <span className="agent-indicator">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2a2 2 0 0 1 2 2c0 .74-.4 1.39-1 1.73V7h1a7 7 0 0 1 7 7h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1.07A7.001 7.001 0 0 1 14 23h-4a7.001 7.001 0 0 1-6.93-4H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1a7 7 0 0 1 7-7h1V5.73c-.6-.34-1-.99-1-1.73a2 2 0 0 1 2-2zm-4 13a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm8 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"/>
          </svg>
        </span>
      </div>

      <div className="message-body">
        <div className="message-meta">
          <span className="message-sender">{sender?.username || agentMeta.agent_name || 'Agent'}</span>
          <span className="agent-badge">
            {message.sender_type === 'plugin' ? 'PLUGIN' : 'PERSONA'}
          </span>
          {agentMeta.model && <span className="agent-model">{agentMeta.model}</span>}
          <span className="message-time">{formatTime(timestamp)}</span>
          {auditTrail && <AuditBadge />}
        </div>

        {hasThinking && (
          <div className="thinking-block">
            <button className="thinking-toggle" onClick={() => setOpen(v => !v)}>
              <span className="thinking-dot" />
              <span className="thinking-label">{thinkLabel}</span>
              <svg
                width="10" height="10" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" strokeWidth="2.5"
                style={{ transition: 'transform 0.15s', transform: open ? 'rotate(180deg)' : 'rotate(0deg)', color: '#ccc' }}
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>

            {open && (
              <div className="thinking-body">
                {thinking && (
                  <p className="thinking-cot">{thinking}</p>
                )}
                {toolCalls.map((tc, i) => (
                  <div key={i} className="thinking-tool">
                    <div className="thinking-tool-header">
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="4 17 10 11 4 5" /><line x1="12" y1="19" x2="20" y2="19" />
                      </svg>
                      <span className="thinking-tool-name">{tc.name}</span>
                      <span className="thinking-tool-pill">✓ done</span>
                    </div>
                    {tc.arguments && Object.keys(tc.arguments).length > 0 && (
                      <pre className="thinking-tool-args">
                        {Object.entries(tc.arguments).map(([k, v]) =>
                          `${k}: ${typeof v === 'string' ? v : JSON.stringify(v)}`
                        ).join('\n')}
                      </pre>
                    )}
                    {tc.result !== undefined && (
                      <div className="thinking-tool-result">
                        → {typeof tc.result === 'string' ? tc.result : JSON.stringify(tc.result)}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        <div className="message-content agent-content">
          <MessageContent content={content} />
        </div>
      </div>
    </>
  )
}
